export const QuestsMock: string = `
[{"title":"A Fairy Tale I - Growing Pains","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Animal Magnetism","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Another Slice of H.A.M.","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Bar Crawl (miniquest)","status":"COMPLETED"
,"difficulty":1,"members":true,"questPoints":0,"userEligible":true},
{"title":"Biohazard","status":"COMPLETED"
,"difficulty":0,"members":true,"questPoints":3,"userEligible":true},
{"title":"Buyers and Cellars","status":"COMPLETED"
,"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Carnillean Rising","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Cook's Assistant","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true}
,{"title":"Death Plateau","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Death to the Dorgeshuun","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Desert Treasure","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":3,"userEligible":true},
{"title":"Diamond in the Rough","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Dragon Slayer","status":"COMPLETED",
"difficulty":2,"members":false,"questPoints":2,"userEligible":true},
{"title":"Druidic Ritual","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":4,"userEligible":true},
{"title":"Ernest the Chicken","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":4,"userEligible":true},
{"title":"Fight Arena","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Fishing Contest","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"From Tiny Acorns (miniquest)","status":"COMPLETED"
,"difficulty":0,"members":true,"questPoints":0,"userEligible":true},
{"title":"Gertrude's Cat","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Goblin Diplomacy","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":5,"userEligible":true},
{"title":"Gunnar's Ground","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":5,"userEligible":true},
{"title":"Hazeel Cult","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Holy Grail","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Horror from the Deep","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Icthlarin's Little Helper","status":"COMPLETED"
,"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Imp Catcher","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"In Aid of the Myreque","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"In Search of the Myreque","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Jungle Potion","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Land of the Goblins","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"Lost City","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":3,"userEligible":true},
{"title":"Merlin's Crystal","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":6,"userEligible":true},
{"title":"Monkey Madness","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":3,"userEligible":true},
{"title":"Myths of the White Lands","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":2,"userEligible":true},
{"title":"Nature Spirit","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":2,"userEligible":true},
{"title":"One Piercing Note","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":2,"userEligible":true},
{"title":"One Small Favour","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Pirate's Treasure","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":2,"userEligible":true},
{"title":"Plague City","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Priest in Peril","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Recruitment Drive","status":"COMPLETED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Regicide","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":3,"userEligible":true},
{"title":"Roving Elves","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":true},
{"title":"Sheep Shearer (miniquest)","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":0,"userEligible":true},
{"title":"Shield of Arrav","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Shilo Village","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Smoking Kills","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Song from the Depths","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Spirits of the Elid","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Stolen Hearts","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":3,"userEligible":true},
{"title":"Swept Away","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":2,"userEligible":true},
{"title":"Tears of Guthix","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Temple of Ikov","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"The Blood Pact","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"The Chosen Commander","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":3,"userEligible":true},
{"title":"The Curse of Zaros (miniquest)","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":true},
{"title":"The Darkness of Hallowvale","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"The Dig Site","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"The Elder Kiln","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":2,"userEligible":true},
{"title":"The Firemaker's Curse","status":"COMPLETED",
"difficulty":3,"members":true,"questPoints":2,"userEligible":true},
{"title":"The General's Shadow (miniquest)","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":0,"userEligible":true},
{"title":"The Giant Dwarf","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"The Grand Tree","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":5,"userEligible":true},
{"title":"The Knight's Sword","status":"COMPLETED",
"difficulty":1,"members":false,"questPoints":1,"userEligible":true},
{"title":"The Lost Tribe","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"The Restless Ghost","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"The Tourist Trap","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Tree Gnome Village","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Troll Stronghold","status":"COMPLETED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"Underground Pass","status":"COMPLETED"
,"difficulty":2,"members":true,"questPoints":5,"userEligible":true},
{"title":"Unstable Foundations","status":"COMPLETED"
,"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Vampyre Slayer","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":3,"userEligible":true},
{"title":"Waterfall Quest","status":"COMPLETED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Witch's House","status":"COMPLETED",
"difficulty":1,"members":false,"questPoints":4,"userEligible":true},
{"title":"Witch's Potion (miniquest)","status":"COMPLETED",
"difficulty":0,"members":false,"questPoints":0,"userEligible":true},
{"title":"Heroes' Quest","status":"STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"Lost Her Marbles (miniquest)","status":"STARTED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":true},
{"title":"The Tale of the Muspah","status":"STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"'Phite Club","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"A Clockwork Syringe","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"A Fairy Tale II - Cure a Queen","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"A Fairy Tale III - Battle at Ork's Rift","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"A Guild of Our Own (miniquest)","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":0,"userEligible":false},
{"title":"A Shadow over Ashdale","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"A Soul's Bane","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"A Tail of Two Cats","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"A Void Dance","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":false},
{"title":"Abyss (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":false},
{"title":"All Fired Up","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"As a First Resort","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":false},
{"title":"Back to my Roots","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Back to the Freezer","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Beneath Cursed Tides","status":"NOT_STARTED",
"difficulty":1,"members":false,"questPoints":1,"userEligible":true},
{"title":"Benedict's World Tour (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":false,"questPoints":0,"userEligible":true},
{"title":"Between a Rock...","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Big Chompy Bird Hunting","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Birthright of the Dwarves","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":2,"userEligible":false},
{"title":"Blood Runs Deep","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":2,"userEligible":false},
{"title":"Boric's Task I (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":false},
{"title":"Boric's Task II (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":false},
{"title":"Boric's Task III (miniquest)","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":0,"userEligible":false},
{"title":"Bringing Home the Bacon","status":"NOT_STARTED"
,"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Broken Home","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Cabin Fever","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Call of the Ancestors","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Catapult Construction","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":2,"userEligible":true},
{"title":"Chef's Assistant","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":1,"userEligible":true},
{"title":"Children of Mah","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":2,"userEligible":false},
{"title":"Clock Tower","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Cold War","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":true},
{"title":"Contact!","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":true},
{"title":"Creature of Fenkenstrain","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Crocodile Tears","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Curse of the Black Stone","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":4,"userEligible":false},
{"title":"Damage Control (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Deadliest Catch","status":"NOT_STARTED"
,"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Dealing with Scabaras","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Defender of Varrock","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Demon Slayer","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":3,"userEligible":true},
{"title":"Desert Slayer Dungeon (miniquest)","status":"NOT_STARTED"
,"difficulty":1,"members":true,"questPoints":0,"userEligible":false},
{"title":"Desperate Times","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":3,"userEligible":false},
{"title":"Devious Minds","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":false},
{"title":"Dimension of Disaster","status":"NOT_STARTED",
"difficulty":250,"members":true,"questPoints":2,"userEligible":true},
{"title":"Dimension of Disaster: Coin of the Realm","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Dimension of Disaster: Curse of Arrav","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Dimension of Disaster: Defender of Varrock","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Dimension of Disaster: Demon Slayer","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":3,"userEligible":false},
{"title":"Dimension of Disaster: Shield of Arrav","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":false},
{"title":"Dishonour among Thieves","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":false},
{"title":"Do No Evil","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Doric's Task I (miniquest)","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":0,"userEligible":false},
{"title":"Doric's Task II (miniquest)","status":"NOT_STARTED",
"difficulty":0,"members":false,"questPoints":0,"userEligible":false},
{"title":"Doric's Task III (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":false,"questPoints":0,"userEligible":false},
{"title":"Doric's Task IV (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":false,"questPoints":0,"userEligible":false},
{"title":"Doric's Task V (miniquest)","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":0,"userEligible":false},
{"title":"Doric's Task VI (miniquest)","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":0,"userEligible":false},
{"title":"Doric's Task VII (miniquest)","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":0,"userEligible":false},
{"title":"Doric's Task VIII (miniquest)","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":0,"userEligible":false},
{"title":"Dream Mentor","status":"NOT_STARTED","difficulty":3,"members":true,"questPoints":2,"userEligible":false},
{"title":"Dwarf Cannon","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Eadgar's Ruse","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"Eagles' Peak","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":2,"userEligible":true},
{"title":"Elemental Workshop I","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"Elemental Workshop II","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":false},
{"title":"Elemental Workshop III","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":false},
{"title":"Elemental Workshop IV","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":false},
{"title":"Enakhra's Lament","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Enlightened Journey","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":false},
{"title":"Evil Dave's Big Day Out","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":false},
{"title":"Eye for an Eye (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Family Crest","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":true},
{"title":"Fate of the Gods","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":2,"userEligible":false},
{"title":"Father and Son","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":0,"userEligible":true},
{"title":"Final Destination (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Flag Fall (miniquest)","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":0,"userEligible":false},
{"title":"Forgettable Tale of a Drunken Dwarf","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Forgiveness of a Chaos Dwarf","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":2,"userEligible":false},
{"title":"Fur 'n Seek","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":2,"userEligible":false},
{"title":"Garden of Tranquillity","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":false},
{"title":"Ghosts Ahoy","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":2,"userEligible":true},
{"title":"Ghosts from the Past (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Glorious Memories","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Gower Quest","status":"NOT_STARTED",
"difficulty":2,"members":false,"questPoints":1,"userEligible":true},
{"title":"Grim Tales","status":"NOT_STARTED",
"difficulty":3,"members":true,"questPoints":1,"userEligible":false},
{"title":"Harbinger (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Haunted Mine","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":true},
{"title":"Head of the Family (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"Heart of Stone","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":false},
{"title":"Helping Laniakea","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":0,"userEligible":true},
{"title":"Hero's Welcome","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":2,"userEligible":false},
{"title":"Hopespear's Will (miniquest)","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":0,"userEligible":true},
{"title":"Hunt for Red Raktuber","status":"NOT_STARTED",
"difficulty":1,"members":true,"questPoints":1,"userEligible":false},
{"title":"Impressing the Locals","status":"NOT_STARTED",
"difficulty":0,"members":true,"questPoints":1,"userEligible":true},
{"title":"In Memory of the Myreque (miniquest)","status":"NOT_STARTED",
"difficulty":4,"members":true,"questPoints":0,"userEligible":false},
{"title":"In Pyre Need","status":"NOT_STARTED",
"difficulty":2,"members":true,"questPoints":1,"userEligible":false}
]`;